import React, { useState, useEffect, useRef, useReducer } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import "./style.scss"
import {
  addFileGasProject,
  getUserBalance,
  getUserInfo,
  resetGasProjectFlag,
  upsertGasProject,
} from "store/actions"
import ProjectDetailsMobile from "./components/ProjectDetailsMobile"
import ProjectDetailsDesktop from "./components/ProjectDetailsDesktop"
import {
  Alert,
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Tag,
  Typography,
  message,
} from "antd"
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
  FileTextOutlined,
  CreditCardOutlined,
  UserOutlined,
} from "@ant-design/icons"
import ConfirmActions from "components/Common/confirm"
import { formatFaDate } from "helpers/utilities"

const { Text, Title } = Typography

const Projects = props => {
  const {
    currentIdGasProject,
    userBalance,
    userInfo,
    matches_sm,
  } = props

  const [errorMessage, setErrorMessage] = useState(null)
  const [insertGasProjectConfirm, setInsertGasProjectConfirm] = useState(false)
  const [isErrorValid, setIsErrorValid] = useState(false)
  const [payProfit, setPayProfit] = useState(0)
  const payProfitRef = useRef(0)
  const [dateCreated, setDateCreated] = useState("")
  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [activeStep, setActiveStep] = useState(0)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      area: "",
      unitNumber: "1",
      floorNumber: "1",
      address: "",
      postalCode: "",
      landlordName: "",
      landlordNaCode: "",
      landlordPhoneNumber: "",
      companyName: "",
      establishment: 0,
      licenseNumber: "",
      des1: "",
      IdSection: 0,
      ownershipTypeEnum: "1",
      inspectionTypeEnum: "1",
      inspectionParameterTypeEnum: 0,
      buildingTypeEnum: "1",
      pipingTypeEnum: "0",
      projectLevelEnum: 0,
      julianRegisterDate: null,
      solarRegisterDate: "",
      description: "",
      julianDateDeliverGas: null,
      solarDateDeliverGas: "",
      isOk: false,
      totalGasUse: 0,
      totalPipeUse: 0,
      regulatorNeed: false,
      paintedPipe: false,
      julianSubmitDate: null,
      solarSubmitDate: null,
      lat: dataAddress.fullAddress.lat,
      lng: dataAddress.fullAddress.lng,
      acceptService: 0,
      unitDes: "",
      hasBurial: false,
    }
  )

  // Unified change handler — keeps same signature as before
  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    if (name === "acceptService") {
      setIsErrorValid(+newValue === 2)
    }
    setFormInput({ [name]: newValue })
  }

  // Ant Design Select/InputNumber adapter
  const handleSelectChange = (name, value) =>
    handleInput({ target: { name, value } })


  const handleValidEventSubmitProject = event => {
    event.preventDefault()
    const { onGetUserBalance } = props
    onGetUserBalance()
    const data = new FormData(event.currentTarget)
    data.forEach((value, name) => {
      setFormInput({ [name]: value })
      if (name === "unitNumber") {
        if (+value > 1) formInput.floorNumber = 0
        payProfitRef.current = Math.round(+formInput.unitNumber * 6036468 + 6036468 * 0.02)
      }
    })
    if (activeStep === 1) setInsertGasProjectConfirm(true)
    if (activeStep === 2) props.history.push("/projects/GasProjects")
    if (!isErrorValid) handleNext(setActiveStep)
  }

  const handleInsertGasProject = async () => {
    const { onUpsertGasProject } = props
    await onUpsertGasProject({
      ...formInput,
      area: +formInput.area,
      unitNumber: +formInput.unitNumber,
      floorNumber: +formInput.floorNumber,
      address: dataAddress.fullAddress.mainAddress,
      IdSection: +dataAddress.sectionId,
      ownershipTypeEnum: +formInput.ownershipTypeEnum,
      inspectionTypeEnum: 1,
      inspectionParameterTypeEnum: 0,
      buildingTypeEnum: +formInput.buildingTypeEnum,
      pipingTypeEnum: +formInput.pipingTypeEnum,
      projectLevelEnum: 0,
      julianRegisterDate: dateCreated.gregorian,
      solarRegisterDate: dateCreated.persian,
      description: "",
      julianDateDeliverGas: null,
      solarDateDeliverGas: "",
      isOk: false,
      totalGasUse: 0,
      totalPipeUse: 0,
      regulatorNeed: false,
      paintedPipe: false,
      hasBurial: !!formInput.hasBurial,
      julianSubmitDate: null,
      solarSubmitDate: null,
      lat: dataAddress.fullAddress.lat,
      lng: dataAddress.fullAddress.lng,
    })
    setInsertGasProjectConfirm(false)
  }

  useEffect(() => {
    const t = setTimeout(() => props.onresetGasProjectFlag(), 3000)
    return () => clearTimeout(t)
  }, [props.success])

  useEffect(() => {
    const t = setTimeout(() => setErrorMessage(null), 3000)
    return () => clearTimeout(t)
  }, [errorMessage])

  useEffect(() => {
    if (errorMessage) message.error(errorMessage)
  }, [errorMessage])

  useEffect(() => {
    if (props.error) message.error(props.error)
  }, [props.error])

  useEffect(() => {
    if (props.success) message.success(props.success)
  }, [props.success])

  const handleNext = setDecrement => {
    setDecrement(prev => prev + 1)
  }
  const handleBack = setIncrement => {
    setIsErrorValid(false)
    setIncrement(prev => prev - 1)
  }

  const stepItems = [
    {
      key: 0,
      title: "تأیید خدمات",
      description: "بررسی و پذیرش شرایط اولیه",
      icon: <CheckCircleFilled />,
      accent: "#1677ff",
      bg: "linear-gradient(135deg, rgba(22,119,255,0.12), rgba(22,119,255,0.03))",
    },
    {
      key: 1,
      title: "اطلاعات پرونده",
      description: "ثبت اطلاعات مالک، ساختمان و موقعیت",
      icon: <FileTextOutlined />,
      accent: "#fa8c16",
      bg: "linear-gradient(135deg, rgba(250,140,22,0.12), rgba(250,140,22,0.03))",
    },
    {
      key: 2,
      title: "مالی و نهایی‌سازی",
      description: "مرور هزینه و تکمیل ثبت پرونده",
      icon: <CreditCardOutlined />,
      accent: "#52c41a",
      bg: "linear-gradient(135deg, rgba(82,196,26,0.12), rgba(82,196,26,0.03))",
    },
  ]

  return (
    <div className="page-content">
      <MetaTags>
        <title>پرونده | واحد گاز</title>
      </MetaTags>

      <Card
        bordered={false}
        style={{
          marginBottom: matches_sm ? 8 : 12,
          borderRadius: matches_sm ? 14 : 18,
          background: "linear-gradient(135deg, rgba(255,77,79,0.12), rgba(255,120,117,0.06))",
          boxShadow: "0 8px 24px rgba(255,77,79,0.12)",
          border: "1px solid rgba(255,77,79,0.18)",
        }}
        bodyStyle={{ padding: matches_sm ? "10px 12px" : "14px 18px" }}
      >
        <Space align="start" size={matches_sm ? 8 : 12} style={{ width: "100%" }}>
          <Avatar
            size={matches_sm ? 36 : 42}
            icon={<ExclamationCircleFilled />}
            style={{
              backgroundColor: "#ff4d4f",
              borderRadius: matches_sm ? 10 : 12,
              boxShadow: "0 6px 16px rgba(255,77,79,0.25)",
            }}
          />
          <Space direction="vertical" size={4} style={{ flex: 1 }}>
            <Space size={8} wrap>
              <Text strong style={{ fontSize: matches_sm ? 13 : 15, color: "#cf1322" }}>
                هشدار مهم
              </Text>
              {!matches_sm && (
                <Tag color="error" style={{ borderRadius: 999 }}>
                  غیرقابل تغییر پس از تأیید
                </Tag>
              )}
            </Space>
            <Text style={{ color: "#5c0011", lineHeight: 1.9, fontSize: matches_sm ? 12 : 14 }}>
              بعد از تأیید طراحی، تغییر تعداد واحد و نوع لوله‌گذاری امکان‌پذیر نخواهد بود.
            </Text>
             <Text style={{ color: "#5c0011", lineHeight: 1.9, fontSize: matches_sm ? 12 : 14 }}>
              طبق مصوبه جلسه با شرکت گاز استان کردستان،اصلاح ویا جایگزینی نقشه بعد از تایید نهایی توسط بازرس امکان پذیر نیست و لازم است پرونده مجددا تشکیل گردد.
            </Text>
             <Text style={{ color: "#5c0011", lineHeight: 1.9, fontSize: matches_sm ? 12 : 14 }}>
              طبق مصوبه جلسه با شرکت گاز استان کردستان،تست فشار لوله رابط مابین کنتور و رگولاتور الزامیست.
            </Text>
             <Text style={{ color: "#5c0011", lineHeight: 1.9, fontSize: matches_sm ? 12 : 14 }}>
              ویرایش مشخصات، کد پستی و نام مالک پس از ارسال پرونده به شرکت گاز امکان پذیر نیست.
            </Text>
          </Space>
        </Space>
      </Card>

      <Card
        style={{
          borderRadius: matches_sm ? 12 : 16,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          marginBottom: matches_sm ? 8 : 12,
        }}
        bodyStyle={matches_sm ? { padding: 12 } : undefined}
      >
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <Title level={matches_sm ? 5 : 4} style={{ margin: 0 }}>
            پیش ثبت نام پرونده {formatFaDate(new Date())}
          </Title>
        </Space>

        {/* Top controls: inspection type, ownership, date */}
        {activeStep == 0 && (
        <Row gutter={[matches_sm ? 8 : 12, matches_sm ? 8 : 12]} align="stretch" style={{ marginTop: matches_sm ? 8 : 12 }}>
          <Col xs={24} md={8}>
            <Card
              size="small"
              bordered={false}
              style={{
                height: "100%",
                borderRadius: matches_sm ? 12 : 14,
                background: "linear-gradient(135deg, rgba(22,119,255,0.08), rgba(22,119,255,0.02))",
                border: "1px solid rgba(22,119,255,0.12)",
              }}
              bodyStyle={{ padding: matches_sm ? 10 : 14 }}
            >
              <Space direction="vertical" size={matches_sm ? 8 : 10} style={{ width: "100%" }}>
                <Space size={8}>
                  <Avatar
                    size={matches_sm ? 30 : 34}
                    icon={<FileTextOutlined />}
                    style={{ backgroundColor: "#1677ff", borderRadius: matches_sm ? 8 : 10 }}
                  />
                  <Space direction="vertical" size={0}>
                    <Text strong style={{ fontSize: matches_sm ? 13 : 14 }}>نوع بازرسی : خانگی</Text>
                  </Space>
                </Space>

                {/* <Radio.Group
                  name="inspectionTypeEnum"
                  value={formInput.inspectionTypeEnum || "1"}
                  onChange={handleInput}
                  style={{ width: "100%" }}
                >
                  <Radio.Button
                    value="1"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      borderRadius: 10,
                      height: matches_sm ? 42 : 38,
                      lineHeight: matches_sm ? "40px" : "36px",
                      fontWeight: 600,
                    }}
                  >
                    بازرسی خانگی
                  </Radio.Button>
                </Radio.Group> */}
              </Space>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              size="small"
              bordered={false}
              style={{
                height: "100%",
                borderRadius: matches_sm ? 12 : 14,
                background: "linear-gradient(135deg, rgba(250,140,22,0.08), rgba(250,140,22,0.02))",
                border: "1px solid rgba(250,140,22,0.12)",
              }}
              bodyStyle={{ padding: matches_sm ? 10 : 14 }}
            >
              <Space direction="vertical" size={matches_sm ? 8 : 10} style={{ width: "100%" }}>
                <Space size={8}>
                  <Avatar
                    size={matches_sm ? 30 : 34}
                    icon={<UserOutlined />}
                    style={{ backgroundColor: "#fa8c16", borderRadius: matches_sm ? 8 : 10 }}
                  />
                  <Space direction="vertical" size={0}>
                    <Text strong style={{ fontSize: matches_sm ? 13 : 14 }}>نوع مالکیت</Text>
                    {!matches_sm && (
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        فقط در مرحله اول قابل تغییر است
                      </Text>
                    )}
                  </Space>
                </Space>

                <Radio.Group
                  name="ownershipTypeEnum"
                  value={formInput.ownershipTypeEnum || "1"}
                  onChange={handleInput}
                  disabled={activeStep !== 0}
                  buttonStyle="solid"
                  style={{ display: "flex", width: "100%" }}
                >
                  <Radio.Button
                    value="1"
                    style={{ flex: 1, textAlign: "center", height: matches_sm ? 42 : 38, lineHeight: matches_sm ? "40px" : "36px" }}
                  >
                    حقیقی
                  </Radio.Button>
                  <Radio.Button
                    value="2"
                    style={{ flex: 1, textAlign: "center", height: matches_sm ? 42 : 38, lineHeight: matches_sm ? "40px" : "36px" }}
                  >
                    حقوقی
                  </Radio.Button>
                </Radio.Group>
              </Space>
            </Card>
          </Col>

        </Row>
        )}
      </Card>

      <Card
        bordered={false}
        style={{
          borderRadius: matches_sm ? 12 : 16,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
        bodyStyle={matches_sm ? { padding: 12 } : undefined}
      >
        <Space direction="vertical" size={matches_sm ? 12 : 16} style={{ width: "100%" }}>
          {matches_sm ? (
            <Space
              size={0}
              style={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
                padding: "8px 0",
              }}
            >
              {stepItems.map((item, index) => {
                const isActive = activeStep === item.key
                const isDone = activeStep > item.key
                return (
                  <React.Fragment key={item.key}>
                    <Space direction="vertical" align="center" size={4} style={{ minWidth: 80 }}>
                      <Avatar
                        size={38}
                        icon={item.icon}
                        style={{
                          backgroundColor: isActive || isDone ? item.accent : "#d9d9d9",
                          boxShadow: isActive ? `0 4px 12px ${item.accent}44` : "none",
                          transition: "all 0.2s ease",
                        }}
                      />
                      <Text
                        strong
                        style={{
                          fontSize: 11,
                          color: isActive ? item.accent : isDone ? "#52c41a" : "#999",
                        }}
                      >
                        {item.title}
                      </Text>
                      <Tag
                        color={isDone ? "success" : isActive ? "processing" : "default"}
                        style={{
                          borderRadius: 999,
                          fontSize: 10,
                          lineHeight: "18px",
                          padding: "0 6px",
                        }}
                      >
                        {isDone ? "✓" : isActive ? "جاری" : index + 1}
                      </Tag>
                    </Space>
                    {index < stepItems.length - 1 && (
                      <Divider
                        type="vertical"
                        style={{
                          height: 2,
                          width: 28,
                          borderWidth: 2,
                          borderColor: activeStep > index ? stepItems[index].accent : "#e8e8e8",
                          marginTop: 18,
                          transition: "all 0.2s ease",
                        }}
                      />
                    )}
                  </React.Fragment>
                )
              })}
            </Space>
          ) : (
            <Row gutter={[12, 12]}>
              {stepItems.map((item, index) => {
                const isActive = activeStep === item.key
                const isDone = activeStep > item.key
                return (
                  <Col xs={24} md={8} key={item.key}>
                    <Card
                      bordered={false}
                      style={{
                        borderRadius: 16,
                        background: isActive || isDone ? item.bg : "#fafafa",
                        boxShadow: isActive
                          ? `0 8px 24px ${item.accent}22`
                          : "0 1px 6px rgba(0,0,0,0.05)",
                        border: `1px solid ${isActive || isDone ? `${item.accent}55` : "#f0f0f0"}`,
                        transition: "all 0.2s ease",
                      }}
                      bodyStyle={{ padding: 16 }}
                    >
                      <Space align="start" size={12} style={{ width: "100%" }}>
                        <Avatar
                          size={42}
                          icon={item.icon}
                          style={{
                            borderRadius: 12,
                            backgroundColor: isActive || isDone ? item.accent : "#d9d9d9",
                            boxShadow: isActive ? `0 6px 18px ${item.accent}55` : "none",
                          }}
                        />
                        <Space direction="vertical" size={2} style={{ flex: 1 }}>
                          <Space size={8} wrap>
                            <Text strong style={{ fontSize: 14 }}>
                              {item.title}
                            </Text>
                            <Tag
                              color={isDone ? "success" : isActive ? "processing" : "default"}
                              style={{ borderRadius: 999 }}
                            >
                              {isDone ? "تکمیل شد" : isActive ? "مرحله جاری" : `مرحله ${index + 1}`}
                            </Tag>
                          </Space>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            {item.description}
                          </Text>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                )
              })}
            </Row>
          )}

          <Card
            bordered={false}
            style={{
              borderRadius: matches_sm ? 14 : 18,
              background: "linear-gradient(180deg, #ffffff 0%, #fcfcfc 100%)",
              boxShadow: "0 4px 20px rgba(15,23,42,0.06)",
            }}
            bodyStyle={{ padding: matches_sm ? 12 : 20 }}
          >
            <form onSubmit={handleValidEventSubmitProject}>
              <div style={{ minHeight: matches_sm ? 280 : 400 }}>

                {/* ── Step 0: Accept service ── */}
                {activeStep === 0 && (
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: matches_sm ? 260 : 340,
                    paddingTop: matches_sm ? 8 : 16,
                  }}>
                    <div style={{
                      width: matches_sm ? 72 : 88,
                      height: matches_sm ? 72 : 88,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(22,119,255,0.12), rgba(19,194,194,0.12))",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: matches_sm ? 12 : 20,
                    }}>
                      <FileTextOutlined style={{ fontSize: matches_sm ? 32 : 40, color: "#1677ff" }} />
                    </div>
                    <Title level={matches_sm ? 5 : 4} style={{ marginBottom: 4, textAlign: "center" }}>
                      شرایط استفاده از خدمات
                    </Title>
                    <Text type="secondary" style={{
                      fontSize: matches_sm ? 12 : 14,
                      textAlign: "center",
                      maxWidth: 420,
                      lineHeight: 2,
                      marginBottom: matches_sm ? 16 : 24,
                    }}>
                      برای بهره‌مندی از این سامانه ۲٪ مازاد بر تعرفه از کیف پول شما برداشت می‌شود
                    </Text>

                    <Radio.Group
                      name="acceptService"
                      value={formInput.acceptService}
                      onChange={handleInput}
                      style={{ width: matches_sm ? "100%" : "auto", maxWidth: 400 }}
                    >
                      <Row gutter={[12, 12]}>
                        <Col xs={12}>
                          <Card
                            size="small"
                            hoverable
                            style={{
                              borderRadius: 14,
                              border: formInput.acceptService == "1" ? "2px solid #52c41a" : "1.5px solid #e8e8e8",
                              cursor: "pointer",
                              background: formInput.acceptService == "1"
                                ? "linear-gradient(135deg, rgba(82,196,26,0.08), rgba(82,196,26,0.02))"
                                : "#fafafa",
                              textAlign: "center",
                              transition: "all 0.3s ease",
                            }}
                            bodyStyle={{ padding: matches_sm ? "16px 8px" : "20px 12px" }}
                            onClick={() => handleInput({ target: { name: "acceptService", value: "1" } })}
                          >
                            <Space direction="vertical" size={6} align="center">
                              <div style={{
                                width: 40, height: 40, borderRadius: "50%",
                                background: formInput.acceptService == "1" ? "#52c41a" : "#f0f0f0",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                transition: "all 0.3s ease",
                              }}>
                                <CheckCircleFilled style={{
                                  fontSize: 20,
                                  color: formInput.acceptService == "1" ? "#fff" : "#bbb",
                                }} />
                              </div>
                              <Radio value="1" style={{ margin: 0 }}>
                                <Text strong style={{
                                  color: formInput.acceptService == "1" ? "#52c41a" : "#666",
                                  fontSize: matches_sm ? 14 : 15,
                                }}>موافقم</Text>
                              </Radio>
                            </Space>
                          </Card>
                        </Col>
                        <Col xs={12}>
                          <Card
                            size="small"
                            hoverable
                            style={{
                              borderRadius: 14,
                              border: formInput.acceptService == "2" ? "2px solid #ff4d4f" : "1.5px solid #e8e8e8",
                              cursor: "pointer",
                              background: formInput.acceptService == "2"
                                ? "linear-gradient(135deg, rgba(255,77,79,0.08), rgba(255,77,79,0.02))"
                                : "#fafafa",
                              textAlign: "center",
                              transition: "all 0.3s ease",
                            }}
                            bodyStyle={{ padding: matches_sm ? "16px 8px" : "20px 12px" }}
                            onClick={() => handleInput({ target: { name: "acceptService", value: "2" } })}
                          >
                            <Space direction="vertical" size={6} align="center">
                              <div style={{
                                width: 40, height: 40, borderRadius: "50%",
                                background: formInput.acceptService == "2" ? "#ff4d4f" : "#f0f0f0",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                transition: "all 0.3s ease",
                              }}>
                                <ExclamationCircleFilled style={{
                                  fontSize: 20,
                                  color: formInput.acceptService == "2" ? "#fff" : "#bbb",
                                }} />
                              </div>
                              <Radio value="2" style={{ margin: 0 }}>
                                <Text strong style={{
                                  color: formInput.acceptService == "2" ? "#ff4d4f" : "#666",
                                  fontSize: matches_sm ? 14 : 15,
                                }}>عدم موافقت</Text>
                              </Radio>
                            </Space>
                          </Card>
                        </Col>
                      </Row>
                    </Radio.Group>
                  </div>
                )}

                {/* ── Step 1: Project details ── */}
                {activeStep === 1 && matches_sm && (
                  <ProjectDetailsMobile
                    formInput={formInput}
                    handleInput={handleInput}
                    handleSelectChange={handleSelectChange}
                    setIsErrorValid={setIsErrorValid}
                    matches_sm={matches_sm}
                    userInfo={userInfo}
                    dataAddress={dataAddress}
                    setDataAddress={setDataAddress}
                  />
                )}

                {activeStep === 1 && !matches_sm && (
                  <ProjectDetailsDesktop
                    formInput={formInput}
                    handleInput={handleInput}
                    handleSelectChange={handleSelectChange}
                    setIsErrorValid={setIsErrorValid}
                    matches_sm={matches_sm}
                    userInfo={userInfo}
                    dataAddress={dataAddress}
                    setDataAddress={setDataAddress}
                  />
                )}

                {/* ── Step 2: Payment info ── */}
                {activeStep === 2 && (
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: matches_sm ? 260 : 340,
                    paddingTop: matches_sm ? 8 : 16,
                  }}>
                    <Card
                      bordered={false}
                      style={{
                        borderRadius: 20,
                        width: "100%",
                        maxWidth: 520,
                        overflow: "hidden",
                      }}
                      bodyStyle={{ padding: 0 }}
                    >
                      {/* Gradient header */}
                      <div style={{
                        background: "linear-gradient(135deg, #1677ff, #0958d9)",
                        padding: matches_sm ? "20px 16px" : "28px 24px",
                        textAlign: "center",
                        position: "relative",
                        overflow: "hidden",
                      }}>
                        <div style={{
                          position: "absolute", top: -15, right: -15,
                          width: 60, height: 60, borderRadius: "50%",
                          background: "rgba(255,255,255,0.08)",
                        }} />
                        <div style={{
                          position: "absolute", bottom: -20, left: -10,
                          width: 50, height: 50, borderRadius: "50%",
                          background: "rgba(255,255,255,0.06)",
                        }} />
                        <div style={{
                          width: matches_sm ? 48 : 56, height: matches_sm ? 48 : 56,
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.2)",
                          display: "inline-flex", alignItems: "center", justifyContent: "center",
                          marginBottom: 12,
                          border: "2px solid rgba(255,255,255,0.3)",
                        }}>
                          <CreditCardOutlined style={{ fontSize: matches_sm ? 24 : 28, color: "#fff" }} />
                        </div>
                        <Title level={5} style={{ margin: 0, color: "#fff", fontSize: matches_sm ? 14 : 16 }}>
                          پرداخت پیش‌پرداخت
                        </Title>
                      </div>

                      {/* Info body */}
                      <div style={{ padding: matches_sm ? "16px 14px" : "24px 24px" }}>
                        <div style={{
                          borderRadius: 12,
                          background: "#f6f8ff",
                          padding: matches_sm ? 12 : 16,
                          marginBottom: 16,
                          border: "1px solid #e6f0ff",
                        }}>
                          <Text style={{ fontSize: matches_sm ? 12 : 13, lineHeight: 2, color: "#333" }}>
                            پیش‌پرداخت طراحی به صورت علی‌الحساب طبق آخرین تعرفه <Tag color="blue" style={{ borderRadius: 4, margin: "0 2px" }}>G4</Tag> محاسبه می‌شود
                          </Text>
                        </div>

                        <Alert
                          type="warning"
                          showIcon
                          style={{ borderRadius: 10, fontSize: matches_sm ? 11 : 12 }}
                          message={
                            <Text style={{ fontSize: matches_sm ? 11 : 12 }}>
                              در صورت تغییر سایز کنتور / تعداد واحد / نوع لوله‌کشی، تعرفه مجدداً محاسبه خواهد شد
                            </Text>
                          }
                        />

                        {isErrorValid && (
                          <div style={{
                            marginTop: 16,
                            borderRadius: 10,
                            background: "#fff2f0",
                            border: "1px solid #ffccc7",
                            padding: "10px 16px",
                            textAlign: "center",
                          }}>
                            <Text type="danger" style={{ fontSize: matches_sm ? 12 : 13, fontWeight: 600 }}>
                              حداقل باید {-(userBalance - payProfit)} ریال شارژ نمایید
                            </Text>
                          </div>
                        )}
                      </div>
                    </Card>
                  </div>
                )}
              </div>

              {/* Navigation buttons */}
              <div style={{
                marginTop: matches_sm ? 12 : 20,
                padding: matches_sm ? "12px 4px" : "16px 0",
                borderTop: "1px solid #f0f0f0",
              }}>
                <Row justify="space-between" align="middle" gutter={[12, 8]}>
                  <Col xs={matches_sm ? 10 : undefined}>
                    <Button
                      size={matches_sm ? "middle" : "middle"}
                      block={matches_sm}
                      onClick={() => handleBack(setActiveStep)}
                      icon={<ArrowRightOutlined />}
                      disabled={
                        (activeStep === 0 || activeStep === 1) &&
                        currentIdGasProject.length !== 0
                      }
                      style={{
                        borderRadius: 10,
                        height: matches_sm ? 44 : 40,
                        fontWeight: 500,
                        border: "1.5px solid #d9d9d9",
                      }}
                    >
                      مرحله قبل
                    </Button>
                  </Col>
                  {!matches_sm && (
                    <Col>
                      <Space size={4}>
                        {[0, 1, 2].map(s => (
                          <div key={s} style={{
                            width: s === activeStep ? 24 : 8,
                            height: 8,
                            borderRadius: 4,
                            background: s <= activeStep
                              ? "linear-gradient(90deg, #1677ff, #4096ff)"
                              : "#e8e8e8",
                            transition: "all 0.3s ease",
                          }} />
                        ))}
                      </Space>
                    </Col>
                  )}
                  <Col xs={matches_sm ? 14 : undefined}>
                    <Button
                      type="primary"
                      size={matches_sm ? "middle" : "middle"}
                      block={matches_sm}
                      htmlType="submit"
                      icon={<ArrowLeftOutlined />}
                      disabled={isErrorValid || +formInput.acceptService === 0}
                      style={{
                        borderRadius: 10,
                        height: matches_sm ? 44 : 40,
                        fontWeight: 600,
                        background: activeStep === 2
                          ? "linear-gradient(135deg, #52c41a, #73d13d)"
                          : undefined,
                        borderColor: activeStep === 2 ? "#52c41a" : undefined,
                        boxShadow: "0 4px 12px rgba(22,119,255,0.25)",
                      }}
                    >
                      {activeStep === 2 ? "ثبت نهایی" : "مرحله بعد"}
                    </Button>
                  </Col>
                </Row>
              </div>
            </form>
          </Card>
        </Space>
      </Card>

      {insertGasProjectConfirm && (
        <ConfirmActions
          title="پیش ثبت نام پرونده شما انجام شد"
          value={insertGasProjectConfirm}
          handleConfirmFn={handleInsertGasProject}
          handleCancelDialog={setInsertGasProjectConfirm}
          handleCancelFn={handleBack}
          handleCancelFnValue={setActiveStep}
        />
      )}
    </div>
  )
}

const mapStateToProps = ({ GasProjects, USERs }) => ({
  lstGasProjects: GasProjects.lstGasProjects,
  currentIdGasProject: GasProjects.currentIdGasProject,
  CPD: GasProjects.costPermitDomestic,
  CPDP: GasProjects.costPermitDomesticPlus,
  CPI: GasProjects.costPermitIndustrial,
  MUB: GasProjects.minUserBalance,
  error: GasProjects.error,
  success: GasProjects.success,
  loading: GasProjects.loading,
  addedPlanFile: GasProjects.addedPlanFile,
  userBalance: USERs.userBalance,
  userInfo: USERs.userInfo,
})

const mapDispatchToProps = dispatch => ({
  onUpsertGasProject: gasProject => dispatch(upsertGasProject(gasProject)),
  onresetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onGetUserBalance: () => dispatch(getUserBalance()),
  onGetUserInfo: () => dispatch(getUserInfo()),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Projects))

